var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "change-guild-admin-dialog" },
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("m.change_bound_account"),
            visible: _vm.show,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.show = $event
            },
            closed: _vm.closeDialog
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "ruleForm",
              staticClass: "demo-ruleForm",
              attrs: {
                model: _vm.ruleForm,
                size: "small",
                "status-icon": "",
                rules: _vm.rules,
                "label-position": "left",
                "label-width": "180px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "" + _vm.$t("m.agent_id_form"),
                    prop: "guildAdminId"
                  }
                },
                [
                  _c("el-input", {
                    attrs: { type: "text" },
                    model: {
                      value: _vm.ruleForm.guildAdminId,
                      callback: function($$v) {
                        _vm.$set(_vm.ruleForm, "guildAdminId", _vm._n($$v))
                      },
                      expression: "ruleForm.guildAdminId"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "" + _vm.$t("m.BuzzCast_verification_code"),
                    prop: "checkCode"
                  }
                },
                [
                  _c(
                    "el-input",
                    {
                      attrs: { type: "text" },
                      model: {
                        value: _vm.ruleForm.checkCode,
                        callback: function($$v) {
                          _vm.$set(_vm.ruleForm, "checkCode", _vm._n($$v))
                        },
                        expression: "ruleForm.checkCode"
                      }
                    },
                    [
                      _c(
                        "template",
                        { slot: "append" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { disabled: _vm.isChecking },
                              on: { click: _vm.getCheckCode }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.isChecking
                                      ? _vm.secondsLeft + "s"
                                      : _vm.$t("m.get_vercode")
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    2
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { margin: "auto", display: "block" },
                      attrs: { type: "primary", size: "small" },
                      on: {
                        click: function($event) {
                          return _vm.submitForm("ruleForm")
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("m.Confirm")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-76c76406", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76c76406","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/guild/components/changeGuildAdminDialog.vue
// module id = null
// module chunks = 